import { takeEvery } from 'redux-saga/effects';
import Cookies from 'js-cookie';

import { locationChangeAction } from '@/domain/env/envActions';
import { getRuntimeConfig } from '@/lib/runtimeConfig';

function setLocationParams({ payload: locale }) {
  const rtl = locale === 'he';
  const COOKIE_OPTIONS = {
    expires: 365,
    domain: getRuntimeConfig().cognito.REACT_APP_COGNITO_COOKIE_DOMAIN,
  };

  Cookies.set('locale', JSON.stringify({ rtl, locale }), COOKIE_OPTIONS);
  window.location.reload();
}

export default function* ensureChangeLanguage() {
  yield takeEvery(locationChangeAction.type, setLocationParams);
}
